<template>
  <div v-if="institute" class="container mt-4">
    <!-- Institute Profile Card -->
    <div class="card p-4 shadow-sm">
      <div class="d-flex align-items-center">
        <!-- Institute Details (Left Aligned) -->
        <div class="flex-grow-1">
          <h2>{{ institute.institute_name }}</h2>
          <p><i class="bi bi-house-door"></i> Address: {{ institute.address }}</p>
          <p><i class="bi bi-telephone"></i> Contact: {{ institute.contact }}</p>
          <p><i class="bi bi-geo-alt"></i> Location: {{ institute.location ? institute.location.name : 'N/A' }}</p>
          <p><i class="bi bi-person"></i> First Name: {{ institute.user ? institute.user.first_name : 'N/A' }}</p>
          <p><i class="bi bi-person-lines-fill"></i> Last Name: {{ institute.user ? institute.user.last_name : 'N/A' }}</p>
          <p><i class="bi bi-envelope"></i> Email: {{ institute.user ? institute.user.email : 'N/A' }}</p>
        </div>
        <!-- Profile Photo (Right Aligned) -->
        <div v-if="institute.user && institute.user.profile_photo_url" class="ms-4">
          <p><i class="bi bi-image"></i> Profile Photo:</p>
          <img :src="institute.user.profile_photo_url" alt="Profile Photo" class="profile-photo-medium" />
        </div>
        <div v-else class="ms-4">
          <p><i class="bi bi-exclamation-circle"></i> No profile photo available</p>
        </div>
      </div>
    </div>

    <!-- Teachers Table -->
    <div v-if="institute.teach_institutes && institute.teach_institutes.length" class="mt-4">
      <h3><i class="bi bi-person-circle"></i> Teachers</h3>
      <table class="table table-striped table-bordered">
        <thead class="thead-dark">
          <tr>
            <th>#</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Profile Photo</th>
            <th>Subjects</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(teachInstitute, index) in institute.teach_institutes" :key="teachInstitute.id" class="table-hover">
            <td>{{ index + 1 }}</td>
            <td v-if="teachInstitute.teacher && teachInstitute.teacher.user">
              {{ teachInstitute.teacher.user.first_name }}
            </td>
            <td v-else>N/A</td>
            <td v-if="teachInstitute.teacher && teachInstitute.teacher.user">
              {{ teachInstitute.teacher.user.last_name }}
            </td>
            <td v-else>N/A</td>
            <td v-if="teachInstitute.teacher && teachInstitute.teacher.user">
              {{ teachInstitute.teacher.user.email }}
            </td>
            <td v-else>N/A</td>
            <td>
              <div v-if="teachInstitute.teacher && teachInstitute.teacher.user.profile_photo_url">
                <img :src="teachInstitute.teacher.user.profile_photo_url" alt="Profile Photo" class="teacherprofilePhoto profile-photo" />
              </div>
              <div v-else>No photo</div>
            </td>
            <td>
              <ul>
                <li v-for="subject in teachInstitute.subjects" :key="subject.id">
                  {{ subject.name }}
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p><i class="bi bi-exclamation-triangle"></i> No teachers available</p>
    </div>
  </div>
  <div v-else>
    <p>Loading...</p>
  </div>
</template>

<script>
export default {
  props: {
    institute: {
      type: Object,
      default: null
    }
  }
};
</script>

<style scoped>
.profile-photo-medium {
  max-width: 150px;
  max-height: 150px;
  border-radius: 10px;
  object-fit: cover;
  border: 2px solid #ddd;
}

.teacherprofilePhoto{
  max-width: 50px;
  max-height: 50px;
  border-radius: 50%;
}

.card {
  border-radius: 10px;
  background-color: #f9f9f9;
}

.table-hover tbody tr:hover {
  background-color: #f1f1f1;
}

.table th, .table td {
  text-align: center;
}

h3 {
  margin-top: 20px;
}

i {
  margin-right: 8px;
  color: #007bff;
}

h2, h3 {
  font-family: 'Arial', sans-serif;
  font-weight: 600;
}

p {
  font-size: 1.1rem;
}
</style>
